export default __webpack_public_path__ + "assets/models/70a6bdcc1cfe3e5befef9e551c4a6080.glb";